import React, { useState } from 'react';
import { Navigate, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../AdminRoutes';

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(
    searchParams.get('expired') ? 'Your session expired. Sign in again.' : ''
  );
  const [isBusy, setIsBusy] = useState(false);

  // Already signed in — go straight through.
  if (user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    if (isBusy) return;

    if (!email.trim() || !password) {
      setError('Enter your email and password.');
      return;
    }

    setIsBusy(true);
    setError('');
    try {
      await login(email.trim(), password);
      navigate(location.state?.from || '/admin', { replace: true });
    } catch (err) {
      setError(err.message || 'That email and password do not match.');
      setPassword('');
    } finally {
      setIsBusy(false);
    }
  };

  return (
    <div className="spa-login">
      <div className="spa-login__card">
        <div className="spa-login__brand">Starparth Console</div>
        <p className="spa-login__sub">
          Enquiries, applications and site traffic for starparth.com
        </p>

        {error && (
          <div className="spa-login__error" role="alert">
            <i className="fa-solid fa-circle-exclamation" aria-hidden="true" />
            {error}
          </div>
        )}

        <form onSubmit={onSubmit} noValidate>
          <div className="spa-login__field">
            <label className="spa-login__label" htmlFor="admin-email">Email</label>
            <input
              id="admin-email"
              className="spa-input"
              type="email"
              autoComplete="username"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="spa-login__field">
            <label className="spa-login__label" htmlFor="admin-password">Password</label>
            <div style={{ position: 'relative' }}>
              <input
                id="admin-password"
                className="spa-input"
                type={showPassword ? 'text' : 'password'}
                autoComplete="current-password"
                style={{ paddingRight: 40 }}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                onClick={() => setShowPassword((v) => !v)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
                style={{
                  position: 'absolute', right: 6, top: '50%', transform: 'translateY(-50%)',
                  border: 0, background: 'none', color: '#667085', cursor: 'pointer',
                  padding: 6, lineHeight: 1,
                }}
              >
                <i className={`fa-solid ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`} aria-hidden="true" />
              </button>
            </div>
          </div>

          <button
            type="submit"
            className="spa-btn spa-btn--primary"
            style={{ width: '100%', justifyContent: 'center', height: 40, marginTop: 8 }}
            disabled={isBusy}
          >
            {isBusy
              ? <><i className="fa-solid fa-spinner fa-spin" aria-hidden="true" /> Signing in…</>
              : 'Sign in'}
          </button>
        </form>

        <p className="spa-card__note" style={{ marginTop: 20, textAlign: 'center' }}>
          Locked out? Ask a superadmin to reset your access.
        </p>
      </div>
    </div>
  );
}
